function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.414 15l1.647-1.646a.5.5 0 000-.708l-.707-.707a.5.5 0 00-.708 0l-3.282 3.283a1.1 1.1 0 000 1.556l3.282 3.283a.5.5 0 00.708 0l.707-.707a.5.5 0 000-.708L10.414 17H20a3 3 0 110 6h-7a1 1 0 100 2h7a5 5 0 000-10h-9.586z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 26.5a3.5 3.5 0 01-3.5 3.5h-21A3.5 3.5 0 012 26.5V10.18a3 3 0 01.622-1.829l3.685-4.79A4 4 0 019.477 2h13.847a4 4 0 013.406 1.904l2.825 4.59A3 3 0 0130 10.066V26.5zM7.892 4.78A2 2 0 019.477 4h13.847a2 2 0 011.703.952L26.287 7H6.185l1.707-2.22zM4 10.5v16A1.5 1.5 0 005.5 28h21a1.5 1.5 0 001.5-1.5v-16A1.5 1.5 0 0026.5 9h-21A1.5 1.5 0 004 10.5z",
  fill: "currentColor"
})));